export const faqConfig = {
    // Кол-во отображаемых вопросов по умолчанию
    maxShowedCount: 5,
};
